module.exports = __webpack_public_path__ + "static/media/RoadSideAssistance.e73a6b68.svg";